import { createContext, useContext, useMemo } from "react";

type TTSContextType = {
	org: string;
	tenantId: string;
	appId: string;
	appName: string;
};

const TTSContext = createContext<TTSContextType>({
	org: "",
	tenantId: "",
	appId: "",
	appName: "",
});

export const useTTSContext = () => {
	const context = useContext(TTSContext);
	if (!context) {
		throw new Error("useTTSContext must be used within a TTSProvider");
	}
	return context;
};

export const TTSProvider = ({
	children,
	appId,
	appName,
	org,
	tenantId,
}: {
	children: React.ReactNode;
} & TTSContextType) => {
	const value = useMemo(
		() => ({
			appId,
			appName,
			org,
			tenantId,
		}),
		[appId, appName, org, tenantId],
	);

	return <TTSContext.Provider value={value}>{children}</TTSContext.Provider>;
};
